module.exports = __webpack_public_path__ + "static/icon-1-652a3ab1a77dfd561f9b77cd0bf1bd13.svg";